import { AccessControlRole } from './access-control-role.model';
import { AccessControlScope } from './access-control-scope.model';

/**
 * Model for API AccessControlGrant Model
 */
export class AccessControlGrant {
  role: AccessControlRole;

  scope: AccessControlScope;

  constructor(attributes: Partial<AccessControlGrant> = {}) {
    Object.assign(this, attributes);
  }

  equalTo(grant: AccessControlGrant): boolean {
    return this.role.equalTo(grant.role) && this.scope.equalTo(grant.scope);
  }
}
